import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-85" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-86" data-mp="23wmhx6pahhi6">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-green sm:text-xs" data-id="element-87" data-mp="30lu0q6yixcie">
          EL CURRÍCULO COMPLETO DE BIOLOGÍA
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-deep sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-88" data-mp="2mrtak1ln0xtn">
          Enseña un año completo de <span className="italic text-brand-green" data-id="element-89" data-mp="3fh0a93wtvtgh">Biología</span> con solo 5 minutos de
          preparación
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-90" data-mp="3kbe95gap8ipw">
          Biología Lista es la colección completa lista para imprimir: 10 tomos con teoría clara, actividades,
          laboratorios y evaluaciones para Primaria y Secundaria.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/4BcjTUVqCZjd7aQfA87tsU/ChatGPT_Image_24_ago_2026,_15_49_49.png" alt="La colección completa Biología Lista: diez tomos de Primaria y Secundaria, material digital, equipo de laboratorio y cinco bonos de regalo" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-91" data-mp="2p7ejdv9mka6x" />
        <div className="flex w-full flex-col items-center" data-id="element-92" data-mp="381tlvuv5akzi">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-93" data-mp="336e812x50p33">
            QUIERO EL PACK BIOLOGÍA LISTA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-94" data-mp="18sdcos0sqk7r">
            Descarga inmediata <span className="px-1 text-brand-amber" data-id="element-95" data-mp="38vo0grw4tnc4">·</span> Pago único{' '}
            <span className="px-1 text-brand-amber" data-id="element-96" data-mp="3dso4yydc2i14">·</span> Garantía de 7 días
          </p>
        </div>
      </motion.div>
    </section>;
}